import cn from 'classnames';

import { IConDefaultType } from '../types';

interface ILoadingIconProps extends IConDefaultType {}

function LoadingIcon({ className, size = 24, rotate, flip }: ILoadingIconProps) {
  return (
    <i
      className={cn('dds-icon', className, { flip })}
      style={{
        width: size,
        minWidth: size,
        height: size,
        transform: `rotate(${rotate}deg)`,
      }}
    >
      <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M5.81306 8.06753C7.05817 8.06753 8.06753 7.05817 8.06753 5.81306C8.06753 4.56795 7.05817 3.55859 5.81306 3.55859C4.56795 3.55859 3.55859 4.56795 3.55859 5.81306C3.55859 7.05817 4.56795 8.06753 5.81306 8.06753Z"
          fill="#00C3DD"
        />
        <path
          d="M3.25447 14.2607C4.49957 14.2607 5.50893 13.2513 5.50893 12.0062C5.50893 10.7611 4.49957 9.75177 3.25447 9.75177C2.00936 9.75177 1 10.7611 1 12.0062C1 13.2513 2.00936 14.2607 3.25447 14.2607Z"
          fill="#00C3DD"
        />
        <path
          opacity="0.8"
          d="M5.81306 20.4407C7.05817 20.4407 8.06753 19.4313 8.06753 18.1862C8.06753 16.9411 7.05817 15.9318 5.81306 15.9318C4.56795 15.9318 3.55859 16.9411 3.55859 18.1862C3.55859 19.4313 4.56795 20.4407 5.81306 20.4407Z"
          fill="#00C3DD"
        />
        <path
          opacity="0.7"
          d="M12.0074 23C13.2525 23 14.2619 21.9907 14.2619 20.7456C14.2619 19.5004 13.2525 18.4911 12.0074 18.4911C10.7623 18.4911 9.75293 19.5004 9.75293 20.7456C9.75293 21.9907 10.7623 23 12.0074 23Z"
          fill="#00C3DD"
        />
        <path
          opacity="0.5"
          d="M18.1881 20.4407C19.4332 20.4407 20.4425 19.4313 20.4425 18.1862C20.4425 16.9411 19.4332 15.9318 18.1881 15.9318C16.943 15.9318 15.9336 16.9411 15.9336 18.1862C15.9336 19.4313 16.943 20.4407 18.1881 20.4407Z"
          fill="#00C3DD"
        />
        <path
          opacity="0.3"
          d="M20.7447 14.2607C21.9898 14.2607 22.9992 13.2513 22.9992 12.0062C22.9992 10.7611 21.9898 9.75177 20.7447 9.75177C19.4996 9.75177 18.4902 10.7611 18.4902 12.0062C18.4902 13.2513 19.4996 14.2607 20.7447 14.2607Z"
          fill="#00C3DD"
        />
        <path
          opacity="0.1"
          d="M18.1881 8.06753C19.4332 8.06753 20.4425 7.05817 20.4425 5.81306C20.4425 4.56795 19.4332 3.55859 18.1881 3.55859C16.943 3.55859 15.9336 4.56795 15.9336 5.81306C15.9336 7.05817 16.943 8.06753 18.1881 8.06753Z"
          fill="#00C3DD"
        />
      </svg>
    </i>
  );
}

export default LoadingIcon;
